import { render } from "./MediaEditForm.vue?vue&type=template&id=54ba4246"
import script from "./MediaEditForm.vue?vue&type=script&lang=js"
export * from "./MediaEditForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__